import React from 'react';
import clsx from 'clsx';

import { Copy, Icon, Link, NavLink } from '../../components';

type CampaignNameProps = {
  id: string;
  name: string | React.ReactNode;

  inline?: boolean;
  className?: string;

  withId?: boolean;
  withPromptsLink?: boolean;
  withMonitoringLink?: boolean;
  withMonitoringLinkIcon?: boolean;
};

const CampaignName: React.FC<CampaignNameProps> = ({
  id,
  name,
  className,
  inline = false,

  withId = true,
  withPromptsLink = false,
  withMonitoringLink = false,
  withMonitoringLinkIcon = true,
}) => {
  const promptsElement = withPromptsLink && (
    <NavLink to={`/campaigns/system_prompts/${id}`}>
      <Icon icon="prompt" tooltip="View prompts" className="ml-sm shrink-0" />
    </NavLink>
  );

  const nameElement = withMonitoringLink ? (
    <Link withDecoration external={false} url={`/campaign_monitoring/${id}`}>
      {name}
      {withMonitoringLinkIcon && <Icon icon="eye" className="ml-sm" />}
    </Link>
  ) : (
    name
  );

  return (
    <div
      className={clsx(
        className,
        inline ? 'flex flex-row gap-x-md items-center' : ''
      )}
    >
      {/* {name} */}
      {nameElement}
      {promptsElement}
      {!!withId && (
        <div className={!inline ? 'mt-xs' : ''}>
          <span className="text-tiny text-textLight">{id}</span>
          <Copy
            text={id}
            label={false}
            className="ml-sm"
            message="Campaign ID copied successfully!"
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(CampaignName) as typeof CampaignName;
